export default "__VITE_ASSET__D3Wfoz2$__"